export default __webpack_public_path__ + "static/media/stars.e24cb5f8.svg";